import { H2RInput } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate, encode = true }) => {
	return (
		<>
			<H2RInput
				label="Section name"
				value={cue.name}
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg  overflow-hidden">
			<span className="font-semibold text-gray-500">{cue.name || ""}</span>
		</div>
	);
};
